export default class PlayerSearch {
    static init(): void {
        const searchForm = document.getElementById('player-search-form') as HTMLFormElement;
        const searchInput = document.getElementById('player-search-input') as HTMLInputElement;

        if (!searchForm || !searchInput) {
            return;
        }

        // Funkce pro filtrování hráčů
        const filterPlayers = (searchQuery: string): void => {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            // Filtrování pro seznam (table view)
            const playerListItems = document.querySelectorAll('.player-list-item');
            playerListItems.forEach((item) => {
                const nameElement = item.querySelector('.player-list-item__name');
                if (nameElement) {
                    const playerName = nameElement.textContent?.toLowerCase().trim() || '';

                    if (normalizedQuery === '' || playerName.includes(normalizedQuery)) {
                        (item as HTMLElement).style.display = '';
                    } else {
                        (item as HTMLElement).style.display = 'none';
                    }
                }
            });

            // Filtrování pro fotogalerii (grid view)
            const playerSliderItems = document.querySelectorAll('.about-slider-item');
            playerSliderItems.forEach((item) => {
                const titleElement = item.querySelector('.player-slider-content__title');
                if (titleElement) {
                    const playerName = titleElement.textContent?.toLowerCase().trim() || '';

                    if (normalizedQuery === '' || playerName.includes(normalizedQuery)) {
                        (item as HTMLElement).style.display = '';
                    } else {
                        (item as HTMLElement).style.display = 'none';
                    }
                }
            });
        };

        // Event listener pro submit formuláře
        searchForm.addEventListener('submit', (e: Event) => {
            e.preventDefault();
            filterPlayers(searchInput.value);
        });

        // Event listener pro průběžné vyhledávání při psaní
        searchInput.addEventListener('input', () => {
            filterPlayers(searchInput.value);
        });

        // Event listener pro vyčištění vyhledávání
        searchInput.addEventListener('search', () => {
            // Tento event se spustí když uživatel smaže text pomocí X v search inputu
            if (searchInput.value === '') {
                filterPlayers('');
            }
        });
    }
}

